import { create } from "zustand";

export const useExplicitConsentStore = create((set, get) => ({
  // State
  explicitConsents: [],
  loading: false,
  error: null,
  selectedConsent: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  consentToDelete: null,
  isDetailDialogOpen: false,
  consentToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setExplicitConsents: (explicitConsents) => set({ explicitConsents }),
  setSelectedConsent: (consent) => set({ selectedConsent: consent }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedConsent: null,
    error: null
  }),

  openEditForm: (consent) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedConsent: consent,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedConsent: null,
    error: null
  }),

  openDeleteDialog: (consent) => set({
    isDeleteDialogOpen: true,
    consentToDelete: consent,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    consentToDelete: null,
    error: null
  }),

  openDetailDialog: (consent) => set({
    isDetailDialogOpen: true,
    consentToView: consent,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    consentToView: null,
    error: null
  }),

}));
